import { render, staticRenderFns } from "./EventArea.vue?vue&type=template&id=ea286066"
import script from "./EventArea.vue?vue&type=script&lang=js"
export * from "./EventArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea286066')) {
      api.createRecord('ea286066', component.options)
    } else {
      api.reload('ea286066', component.options)
    }
    module.hot.accept("./EventArea.vue?vue&type=template&id=ea286066", function () {
      api.rerender('ea286066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/EventArea.vue"
export default component.exports